import React from 'react';

/* eslint-disable max-len */
const Arrow = () => (
    <svg height="30" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
        <title>TB-pil</title>
        <path
            d="M14.495 10.293c.526.52.518.94.008 1.443l-4.764 4.7c-.25.246-.657.246-.907 0l-.076-.075c-.25-.243-.25-.642 0-.89l4.51-4.45-4.5-4.44c-.25-.244-.25-.644 0-.89l.075-.074c.25-.247.655-.247.906 0l4.744 4.68z"
            fill="#474445"
            fillRule="evenodd"
        />
    </svg>
);

export default Arrow;



// WEBPACK FOOTER //
// ./safeTrade/status/arrow.jsx